import * as React from 'react';
import { Query } from 'react-apollo';

import { tupleToStringKey } from 'js/lib/stringKeyTuple';
import user from 'js/lib/user';

import { courseNextStepQuery } from 'bundles/course-v2/queries/queries';
import type {
  GuidedCourseNextStepsV1,
  GuidedCourseNextStepsV1MultiGetQuery,
  GuidedCourseNextStepsV1MultiGetQueryVariables,
} from 'bundles/naptimejs/resources/__generated__/GuidedCourseNextStepsV1';

type Props = {
  courseSlug: string;
  children: (args: { courseNextStep?: GuidedCourseNextStepsV1; error?: Error }) => React.ReactElement | null;
};

const CourseNextStepProvider: React.FC<Props> = ({ children, courseSlug }) => (
  <Query<GuidedCourseNextStepsV1MultiGetQuery, GuidedCourseNextStepsV1MultiGetQueryVariables>
    query={courseNextStepQuery}
    variables={{ ids: tupleToStringKey([user.get().id, courseSlug]) }}
    fetchPolicy="cache-and-network"
  >
    {({ data, error, loading }) =>
      // There is no point rendering the children if there is no data yet
      data && !loading
        ? children({
            courseNextStep: data?.GuidedCourseNextStepsV1?.multiGet?.elements?.[0],
            error,
          })
        : null
    }
  </Query>
);

export default CourseNextStepProvider;
